module.exports = __webpack_public_path__ + "f4dfd74f10d05619e39fd6f1890325d2.png";